import { startCase } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { useIsMobile } from "@ryde/shared";

import { StationRouteStationsHeaderStyled } from "./station-route.station.styled";

interface IStationsPanelHeaderStationRoute {
  isDragging?: boolean;
}

export const StationsPanelHeaderStationRoute: FC<
  IStationsPanelHeaderStationRoute
> = ({ isDragging }) => {
  const { t } = useTranslation();
  const { isMobile } = useIsMobile();

  return (
    <StationRouteStationsHeaderStyled $isDragging={isDragging}>
      {!isMobile && <div className="column_grip_header" aria-hidden />}
      <div className="column_station_info_h">
        <div className="column_station_header_spacer" aria-hidden />
        <div className="column_station_header">
          {startCase(t("station.single"))}
        </div>
        <div className="column_time_header">{startCase(t("general.TIME"))}</div>
      </div>
      {!isMobile && (
        <div className="column_area_header">{startCase(t("area.single"))}</div>
      )}
      <div className="column_duration_header">{t("general.DURATION")}</div>
      {!isMobile && <div className="column_icons_header" aria-hidden />}
    </StationRouteStationsHeaderStyled>
  );
};
